import { z } from 'zod';

export enum BookerFormKeys {
    customerId = 'customerId',
}

export const BookerFormSchema = z.object({
    [BookerFormKeys.customerId]: z.string().optional().nullable(),
});

export type BookerFormValues = z.infer<typeof BookerFormSchema>;
